import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import { Typography } from "@material-ui/core";

const style = {
  root: {
    height: "14px",
  },
};

function PageTitle(props) {
  return (
    <div className="clear m-t-contact">
      <Typography variant="h1" className={`reset-password ${props.class}`}>{props.label}</Typography>

      {/* {props.hideDivider != true && (
        <div className="TitleBreaker">
          <Divider className={props.classes.root} />
        </div>
      )} */}
    </div>
  );
}

export default withStyles(style)(PageTitle);
